export default __webpack_public_path__ + "static/media/ic_setting.61e6e01a.svg";